export default __webpack_public_path__ + "static/media/information--recycle-collection-center--g1.8a0f22c1.png";